/* eslint-disable max-len */
import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'

import { criteria, monthRevType } from '../../../constants'
import { NumberInput } from '../../../../../../input'
import { FONTS } from '../../../../../../../constants'
import { projectInformationSelector } from '../../../../../../../selectors'
import { REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE } from '../../../../../../../lib/utils/envConstants'

export const ScrollableInput = React.memo((props) => {
  const {
    data,
    isExpand,
    allocation_id,
    handleExpandTable,
    handleChangeScollableInput,
  } = props
  const ppsLatestSubmittedDate = useSelector(projectInformationSelector.getPPSLatestSubmittedDate)
  const isEdit = useSelector(projectInformationSelector.getIsEditRevenuePlanning)
  const { _sumTypeAllocationMonths = [] } = data

  return (
    <Root>
      <Container>
        <Wrapper>
          { _sumTypeAllocationMonths.map((i, key) => (
            <StickyWrapper key={ key } onClick={ () => handleExpandTable(allocation_id) }>
              <HeaderCol>
                <HeaderText>Rev.</HeaderText>
                <HeaderNumber>{`฿ ${i.revenue}`}</HeaderNumber>
              </HeaderCol>
            </StickyWrapper>
          )
          )}
          { _sumTypeAllocationMonths.length < 10 &&
            Array.from({ length: 10 - _sumTypeAllocationMonths.length }, (v, i) => i).map(i => (
              <StickyWrapper key={ i } onClick={ () => handleExpandTable(allocation_id) }>
                <HeaderCol>
                  <HeaderText />
                  <HeaderNumber />
                </HeaderCol>
              </StickyWrapper>
            ))}
        </Wrapper>
        {data.lobs.map((lob, k) => {
          const isDisabled = (lob.criteria === criteria.COMPLETION || lob.criteria === criteria.MD)
          && numeral(lob.lob_revenue).value() === 0
          const showMonthRev = monthRevType[lob.criteria]
          const isMD = lob.criteria === criteria.MD

          return (
            <ColWrapper key={ k } active={ isExpand }>
              <InputRow>
                {lob.lob_months.map((l, v) => {
                  const inRange = moment(l.month).isSameOrBefore(lob.end_date, 'month')
                    && (!REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE && ppsLatestSubmittedDate !== '' && moment(l.month).isSameOrBefore(ppsLatestSubmittedDate, 'month') ?
                      moment(l.month).isAfter(ppsLatestSubmittedDate, 'month')
                      :
                      moment(l.month).isSameOrAfter(lob.start_date, 'month')
                    )
                  if (!inRange && !REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE) {
                    return (
                      <PercentageCol key={ v }>
                        <HeaderText>{ isMD ? 'Mandays' : 'Percentage %' }</HeaderText>
                        <Text>{l.ratio}</Text>
                      </PercentageCol>
                    )
                  }
                  return (
                    <PercentageCol key={ v }>
                      <HeaderText>{ isMD ? 'Mandays' : 'Percentage %' }</HeaderText>
                      <NumberInput
                        name='ratio'
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        allowNegative={ !isMD }
                        disabled={ !isEdit || !inRange || !showMonthRev || isDisabled }
                        value={ l.ratio }
                        onBlur={ e => handleChangeScollableInput(e, allocation_id, k, v, 'ratio') }
                      />
                    </PercentageCol>
                  )
                }
                )}
              </InputRow>
              <InputRow>
                {lob.lob_months.map((l, v) => {
                  const isDisabled = (lob.criteria === criteria.COMPLETION || lob.criteria === criteria.MD)
                            && numeral(lob.lob_revenue).value() === 0
                  const inRange = moment(l.month).isSameOrBefore(lob.end_date, 'month')
                    && (!REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE && ppsLatestSubmittedDate !== '' && moment(l.month).isSameOrBefore(ppsLatestSubmittedDate, 'month') ?
                      moment(l.month).isAfter(ppsLatestSubmittedDate, 'month')
                      :
                      moment(l.month).isSameOrAfter(lob.start_date, 'month')
                    )

                  if (!inRange && !REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE) {
                    return (
                      <RevenueCol key={ v }>
                        <HeaderText>Revenue</HeaderText>
                        <Text>{l.revenue}</Text>
                      </RevenueCol>
                    )
                  }
                  return (
                    <RevenueCol key={ v }>
                      <HeaderText>Revenue</HeaderText>
                      <NumberInput
                        prefix='฿'
                        allowEmptyFormatting={ true }
                        thousandSeparator={ true }
                        decimalScale={ 2 }
                        fixedDecimalScale={ true }
                        allowNegative={ true }
                        disabled={ !isEdit || !inRange || !showMonthRev || isMD || isDisabled }
                        value={ l.revenue }
                        onBlur={ e => handleChangeScollableInput(e, allocation_id, k, v, 'revenue') }
                      />
                    </RevenueCol>
                  )
                }
                )}
              </InputRow>
              <InputRow>
                { lob.lob_months.map((i, key) => <EmptyRow key={ key } />) }
              </InputRow>
            </ColWrapper>
          )
        }
        )}
      </Container>
    </Root>
  )
})

const Root = styled.div`
  display: flex;
  flex-direction: column;
`

const Container = styled.div`
  margin-bottom: 8px;
  background: #FFFFFF;
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  cursor: pointer;
`

const InputRow = styled.div`
  display: flex;
`

const ColWrapper = styled.div`
  display: ${p => (p.active ? 'flex' : 'none')};
  flex-direction: column;
  background: #F9F9F9;
  border-bottom: 1px solid rgba(0,0,0,0.08);
`

const StickyWrapper = styled.div`
  height: 45px;
  width: 125px;
  min-width: 125px;
  display: flex;
  padding: 0 5px;

  :nth-child(1) {
    padding: 0 5px 0 10px;
  }

  :nth-last-child(1) {
    padding: 0 10px 0 5px;
  }
`

const HeaderCol = styled.div`
  width: 125px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  background: #FFFFFF;
`

const PercentageCol = styled.div`
  height: 60px;
  width: 125px;
  max-width: 125px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 10px;
  padding: 12px 5px 0 5px;

  :nth-child(1) {
    padding: 12px 5px 0 10px;
  }

  :nth-last-child(1) {
    padding: 12px 10px 0 5px;
  }
`

const RevenueCol = styled.div`
  height: 50px;
  width: 125px;
  max-width: 125px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 10px;
  padding: 0 5px;

  :nth-child(1) {
    padding: 0 5px 0 10px;
  }

  :nth-last-child(1) {
    padding: 0 10px 0 5px;
  }
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: 10px;
  color: #C4C4C4;
`

const HeaderNumber = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: 12px;
  color: #1A1A17;
`

const EmptyRow = styled.div`
  height: 40px;
  width: 100px;
  margin: 0 5px 0 5px;

  :nth-child(1) {
    margin: 0 5px 0 10px;
  }

  :nth-last-child(1) {
    margin: 0 10px 0 5px;
  }
`

const Text = styled.span`
  height: 30px;
  display: flex;
  align-items: center;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/revenue-table/item/scrollable-input/index.js